// extracted by mini-css-extract-plugin
export default {"removeUserModal":"RRVHIDOzXQZo_2ZSBpgb","modalHeader":"WrZSZKXgldKzz4W1nLK_","modalContent":"NBrrDCHUVSeoIjjnnFd7","confirmActions":"THzIBae6DhCP74NdeXUr"};